import { type ReactNode, useEffect } from 'react';
import type { GetStaticPropsContext } from 'next';
import { useRouter } from 'next/router';
import { NoSSR } from '@/components';
import { useLocale } from '@/hooks/useLocale';
import { CenterLayout } from '@/layout/getCenterLayout';
import { buildAuthAppSigninUrl } from '@/shared/utils/auth';
import { getDefaultStaticProps } from '../../utils';
function AuthAppRedirect() {
  const router = useRouter();
  const {
    locale
  } = useLocale();
  useEffect(() => {
    if (!router.isReady) return;
    const callbackUrl = typeof router.query.callbackUrl === 'string' ? router.query.callbackUrl : undefined;
    window.location.replace(buildAuthAppSigninUrl(locale, callbackUrl));
  }, [router.isReady, router.query.callbackUrl, locale]);
  return null;
}
export default function LoginPage() {
  return <NoSSR data-sentry-element="NoSSR" data-sentry-component="LoginPage" data-sentry-source-file="index.page.tsx">
      <AuthAppRedirect data-sentry-element="AuthAppRedirect" data-sentry-source-file="index.page.tsx" />
    </NoSSR>;
}
export const getStaticProps = async (context: GetStaticPropsContext) => {
  const defaultProps = await getDefaultStaticProps(context);
  return {
    ...defaultProps,
    props: {
      ...defaultProps.props,
      noIndex: true
    }
  };
};
LoginPage.getLayout = (page: ReactNode) => {
  return <CenterLayout showLanguageSelector={true} className={'!mb:pb-[80px] !pb-[80px]'}>
      {page}
    </CenterLayout>;
};